import { ArticlesSliderSection } from "../ArticlesSliderSection";

import { ArticleRecord } from "@features/articles/store";
import { paths } from "@features/routering/paths";
import React, { FC, memo } from "react";

export interface LastArticlesSliderProps {
  className?: string;
  style?: React.CSSProperties;
  data: ArticleRecord[];
}

const _LastArticlesSlider: FC<LastArticlesSliderProps> = (props) => {
  const { ...restProps } = props;

  return (
    <ArticlesSliderSection
      title="Статьи и новости компании"
      withShowAll
      showAllMobileText={"Показать все статьи"}
      showAllLink={paths.articles()}
      {...restProps}
    />
  );
};

export const LastArticlesSlider = memo(_LastArticlesSlider);
